import Container from '@material-ui/core/Container';

export default Container;
